<template>
  <q-layout 
    v-if="state.tab == 'none'"
    view="hHh LpR fFf"
    class="full-height full-width"    
  >
    <q-header class="bg-white text-black" style="border-bottom:1px solid rgb(200, 200, 200);box-shadow: 0px 0px 3px rgb(160, 160, 160);">
      <q-toolbar
      >
        <a :href="homeUrl" ><img src="@/assets/logo_selvasocr_30.png" height="30px" style="margin-left:15px" /></a>
        <q-space />
      </q-toolbar>
    </q-header>

    <div
      class="first-grid full-height full-width"
    >
      <div
        style="grid-column: 2 / 3; grid-row: 1 / 1;"
      >
        <div
          class="item"
        >
          <div 
            class="menu-container"
            v-for="item in filteredMenuItems"
            :key="item.name"
            @click="state.tab = item.name"
          >
            <div
              style="width: 100px; height: 100px; display: flex; flex-direction: column; align-items: center; justify-content: center;"
            >
              <q-icon :name="item.icon" style="font-size: 4rem;"/>
              <span
                style="padding-top: 5px; font-size: 1rem;text-align: center;"
              >
                {{ item.label }}
              </span>
            </div>
            <span
              style="padding-left: 10px; padding-right: 10px; "
              v-html="item.description"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  </q-layout>
  <q-layout 
    v-else
    view="hHh lpR fFf" 
    class="full-height full-width"
  >
    <q-header class="bg-white text-black" style="border-bottom:1px solid rgb(200, 200, 200);box-shadow: 0px 0px 3px rgb(160, 160, 160);">
      <q-toolbar
      >
        <a :href="homeUrl" ><img src="@/assets/logo_selvasocr_30.png" height="30px" style="margin-left:15px" /></a>
        <q-space />
        <q-tabs v-model="state.tab" shrink no-caps stretch inline-label class="text-grey" active-color="primary" style="margin:0px 20px;">
          <q-tab icon="backup_table" name="template" label="Template OCR" v-show="isDev"/>
          <q-tab icon="spellcheck" name="ocr" label="OCR" />
          <q-tab icon="description" name="document" label="Document OCR" />
          <q-tab icon="badge" name="card" label="Card OCR" />
          <q-tab icon="science" name="experimental" label="Experimental" v-show="isDev"/>
          <q-tab icon="videocam" name="media" label="media" />
        </q-tabs>
        <q-space />
        <!--<q-btn dense flat icon="help_outline" @click="state.dialogHelp.show = true" />-->

        <q-btn dense flat icon="account_circle" style="margin-left:2px;margin-right:10px;" v-show="!isDev">
          <q-menu>
            <div class="row no-wrap q-pa-md">
              <div class="column items-center" style="white-space: nowrap;">
                <!-- <div class="text-h6 q-mb-md">소속</div> -->
                <!-- <div class="text">SelvasAI</div> -->
                <!-- <div class="text">Manager</div> -->
                <div class="text-h8 no-wrap q-mb-md">만료 기간</div>
                {{expiredDate}}
              </div>

              <q-separator vertical inset class="q-mx-lg" />

              <div class="column items-center">
                <q-avatar size="42px">
                  <q-icon dense name="face" size="md" />
                </q-avatar>

                <div class="text-subtitle1 q-mt-md q-mb-xs">
                  {{userName}}
                  <q-popup-edit v-model="state.user" :cover="false" :offset="[0, 10]">
                    <q-input color="accent" v-model="state.user" dense autofocus counter>
                      <template v-slot:prepend>
                        <q-icon name="record_voice_over" color="accent" />
                      </template>
                    </q-input>
                  </q-popup-edit>
                </div>

                <template>
                  <a :href="loginUrl">
                    <q-btn color="primary" :label="state.user.isLoggedIn ? 'Logout' : 'Login'"/>
                  </a>
                </template>

                <!-- <q-btn
                  color="primary"
                  :label="state.user.isLoggedIn ? 'Logout' : 'Login'"
                  push
                  size="sm"
                  v-close-popup
                  @click="$q.notify({message: `기능 추가 예정. 사용자를 바꾸려면 LOGOUT 버튼 위에 '${state.user}' 문자열을 클릭하세요.`, icon: 'error',color: 'black'})"
                /> -->
              </div>
            </div>
          </q-menu>
        </q-btn>

      </q-toolbar>
    </q-header>
    
    <template-ocr-app v-if="state.tab == 'template'" />
    <ocr-app v-if="state.tab == 'ocr'" />
    <document-app v-if="state.tab == 'document'" />
    <card-app v-if="state.tab == 'card'" />
    <experimental-app v-if="state.tab == 'experimental'" />
    <media-app v-if="state.tab == 'media'" />
    
    <q-dialog v-model="state.dialogHelp.show" full-width full-height>
      <div class="column full-height full-width bg-white">
        <div class="row text-h6" style="padding:10px 20px;">
          도움말
          <q-space />
          <q-btn dense flat icon="close" v-close-popup>
            <q-tooltip>Close</q-tooltip>
          </q-btn>
        </div>
        <div class="text-grey" style="padding:0px 20px;">
          {{`TemplateOCR - ${state.dialogHelp.slide == 1 ? '템플릿 목록 페이지' : (state.dialogHelp.slide == 2 ? '템플릿 생성 페이지 - 이미지 입력 전' : ( state.dialogHelp.slide == 3? '템플릿 생성 페이지 - 이미지 입력 후' : '테스트 페이지'))}`}}
        </div>
        <div class="column col full-width">
          <q-carousel
            transition-prev="slide-right"
            transition-next="slide-left"
            swipeable
            animated
            v-model="state.dialogHelp.slide"
            navigation
            control-color="primary"
            arrows
            padding
            class="bg-white full-height full-width"
          >
            <q-carousel-slide :name="1" class="column no-wrap flex-center">
              <img src="@/assets/help1.jpg" width="100%" />
            </q-carousel-slide>
            <q-carousel-slide :name="2" class="column no-wrap flex-center">
              <img src="@/assets/help2.jpg" width="100%" />
            </q-carousel-slide>
            <q-carousel-slide :name="3" class="column no-wrap flex-center">
              <img src="@/assets/help3.jpg" width="100%" />
            </q-carousel-slide>
            <q-carousel-slide :name="4" class="column no-wrap flex-center">
              <img src="@/assets/help4.jpg" width="100%" />
            </q-carousel-slide>
          </q-carousel>
        </div>
      </div>
    </q-dialog>
  </q-layout>
</template>

<script>
import TemplateOcrApp from '@/projects/template_ocr/App.vue'
import OcrApp from '@/projects/ocr/App.vue'
import DocumentApp from '@/projects/document/App.vue'
import CardApp from '@/projects/card/App.vue'
import ExperimentalApp from '@/projects/experimental/App.vue'
import MediaApp from '@/projects/media/App.vue'

import UserJS from '@/js/user.js'
import ETC from '@/js/etc.js'

export default {
  name: 'App',
  data: function () {
    const Vue = this
    return {
      state: {
        dialogHelp: {
          show: false,
          slide: 1
        },
        tab: sessionStorage.getItem('selectedTab') || 'none',
        user: {
          name: Vue.$store.state.user.name,
          permission: Vue.$store.state.user.permission,
          expired: Vue.$store.state.user.expired,
          isLoggedIn: Vue.$store.state.user.isLoggedIn
        }
      },      
      menu_items: [
        {
          name: 'template',
          icon: 'backup_table',
          label: 'Template OCR',
          type: 'dev',
          description: '<strong">템플릿 목록 페이지</strong><br>'
        },
        {
          name: 'ocr',
          icon: 'spellcheck',
          label: 'OCR',
          type: 'prod',
          description: '<strong>OCR 페이지</strong><br>이미지에서 텍스트를 추출하는 기본 OCR 기능을 제공합니다. <br> 필기, Natural scene, 문서 등 다양한 이미지에서 텍스트를 인식하고 추출할 수 있습니다.'
        },
        {
          name: 'document',
          icon: 'description',
          label: 'Document OCR',
          type: 'prod',
          description: '<strong>문서 OCR 페이지</strong><br>사업자등록증, 가족관계등록부, 재무제표, 처방전, 진료비세부내역서 및 기타 문서에서 정보를 추출합니다.'
        },
        {
          name: 'card',
          icon: 'badge', 
          label: 'Card OCR',
          type: 'prod',
          description: '<strong>카드 OCR 페이지</strong><br>여권, 신분증, 신용카드 등에서 정보를 추출합니다.<br>신분증의 경우 주민등록증, 운전면허증, 외국인등록증 등을 지원하며 카드 이미지에서 텍스트 정보를 자동으로 인식하여 제공합니다.'
        },
        {
          name: 'experimental',
          icon: 'science',
          label: 'Experimental',
          type: 'dev',
          description: '<strong>실험 페이지</strong>'
        },
        {
          name: 'media',
          icon: 'videocam',
          label: 'media',
          type: 'prod',
          description: '<strong>미디어 페이지</strong><br>얼굴 탐지(Face Detection), 포즈 디텍션(Pose Detection), 셀피 세그멘테이션(Selfie Segmentation) 등 카메라·이미지 기반 비전 AI 기능을 실행하고 결과를 확인할 수 있는 메뉴입니다.'
        }
      ]
    }
  },
  components: {
     TemplateOcrApp,
     OcrApp,
     DocumentApp,
     CardApp,
     ExperimentalApp,
     MediaApp
  },
  watch: {
    'state.user': {
      deep: true,
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        this.$store.commit('user', newVal);
      }
    },
    'state.tab': {
      handler(newVal) {
        sessionStorage.setItem('selectedTab', newVal); // localStorage 대신 sessionStorage 사용
      }
    },
  },
  mounted () {
    /*
    console.log("store: ", this.$store)
    console.log(this.$cornerstoneTools)
    console.log(this.$cornerstone)
    */
    this.$cornerstoneTools.textStyle.setFont('bold 12px sans-serif')
    const Vue = this
    try {
      UserJS.getUserInfo()
      .then( (data) => {
        if (data.name != undefined) {
          Vue.state.user.name = data.name
          Vue.state.user.permission = data.permission
          Vue.state.user.expired = data.expired
          Vue.state.user.isLoggedIn = true
        } else {
          Vue.state.user.name = "Guest"
          Vue.state.user.permission = []
          Vue.state.user.expired = ""
          Vue.state.user.isLoggedIn = false
        }
      })
      .catch( (error) => {
        console.error(`getUerInfo error ${error}`)
        Vue.state.user.name = "Guest"
        Vue.state.user.permission = []
        Vue.state.user.expired = ""
        Vue.state.user.isLoggedIn = false
      })
    } catch (err) {
      Vue.state.user.name = "Guest"
      Vue.state.user.permission = []
      Vue.state.user.expired = ""
      Vue.state.user.isLoggedIn = false
    }
  },
  computed: {
    loginUrl() {
      return this.state.user.isLoggedIn ? `${window.location.href}/logout` : `${window.location.href}/login`;
    },
    userName() {
      return this.state.user.name
    },
    expiredDate() {
      return this.state.user.expired
    },
    isDev() {
      return ETC.isDev()
    },
    homeUrl() {
      // return `${process.env.VUE_APP_URL}`.slice(0, -5)
      return "https://ocr.selvasai.com"
    },
    filteredMenuItems() {
      return this.menu_items.filter(item => item.type === 'prod' || (item.type === 'dev' && ETC.isDev()))
    }
  }
}
</script>

<style>
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#app {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
}

.body {
  display:flex;
  flex-direction:column;
  height:100%;
  width:100%;
  background: rgb(237, 238, 241);
}

.q-toolbar {
  padding-right: 0 !important;
}

.q-toggle__thumb {
  color: red !important;
}

.q-toggle__thumb:after {
  background: rgb(230, 230, 230) !important;
}

.q-toggle__inner--indet .q-toggle__thumb:after {
  background: rgb(3, 169, 244) !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background: #027BE3 !important;
}

.q-toggle__inner.q-toggle__inner--indet {
  color:rgb(41, 182, 246);
}

::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar
{
  width: 6px;
  height: 6px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #555;
}

.first-grid {
  padding-top: 40px;
  display: grid;
  grid-template-columns: 3fr 4fr 3fr;
  grid-template-rows: 1fr;
}

.item {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;  /* 추가: 아이템이 많을 경우 줄바꿈 */
  align-items: center;
  justify-content: center;  /* space-around 대신 center 사용 */
  gap: 10px;  /* 아이템 간 일정한 간격 설정 */
  margin: 0 auto;  /* 중앙 정렬 */
  padding: 20px;  /* 좌우 여백 */
}

.menu-container {
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 100%;  
  padding: 20px;
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.menu-container:hover {
  transform: translateY(-3px);  /* 호버시 약간 위로 올라가는 효과 */
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);  /* 그림자 효과 강화 */
  border-color: #027BE3;  /* 테두리 색상 변경 */
}

.menu-container:active {
  transform: translateY(1px);  /* 클릭시 약간 아래로 내려가는 효과 */
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.menu-container span {
  white-space: pre-line;
  display: block;
}

.menu-container strong {
  display: block;
  padding-bottom: 5px;
}

</style>
